import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('subject', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },


  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`subject/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('subject', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`subject/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`subject/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  Curriculum: {
    getById(id, params = {}) {
      return backofficeService.Api().get(`curriculum/${id}`, { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    getByClassRoom(ClassRoomId) {
      return backofficeService.Api().get(`curriculum/byClassRoom/${ClassRoomId}`)
        .then(r => r.data)
        .catch((e) => { throw e })
    },
  }

}
